export const Activite = {
    Automobile: "Automobile",
    Agricole: "Agricole",
    Moto: "Moto",
    Loisirs: "Loisirs",
    EspacesVerts: "EspaceVerts",
    Camion: "Camion"
}